export const TRADING_CALENDARS = [
  {
    key: 'calendarCode',
    displayValue: 'Calendar Code',
  },
  {
    key: 'date',
    displayValue: 'Date',
    mask: '0000-00-00',
  },
  {
    key: 'description',
    displayValue: 'Description',
  },
];
